<!-- 商品管理index -->

<template>
  <HeaderView title="私域商品管理" />
  <div class="operate-log-table">
    <SearchBar :list="tableInfo.selectedRows" ref="searchBar" @search="search($event)">
      <template #searchRight>
        <div class="buttons_box2">
          <a-button type="primary" @click="openGoodsDeleteModal()">批量删除商品</a-button>
        </div>
        <div class="buttons_box2">
          <a-button type="primary" @click="openChangeSkusModal()">批量修改价格库存</a-button>
        </div>
      </template>
    </SearchBar>

    <Table ref="table" :info="tableInfo" @change-page="changePage">
      <template #goods_name="{ record }">
        <span>{{ record.Title }}</span>
      </template>

      <template #goods_SPU="{ record }">
        <span>{{ record.ItemId }}</span>
      </template>

      <!-- <template #goods_Id="{ record }">
        <span>{{ record.Title }}</span>
      </template> -->

      <!-- <template #XCX_Name="{ record }">
        <span>{{ record.Title }}</span>
      </template> -->

      <template #goods_Type="{ record }">
        <span>{{ record.CatNames && record.CatNames.join("\/") }}</span>
      </template>
      <template #operate="{ record }">
        <div class="buttons_box2">
          <a-button type="primary" @click="openGoodsInfo(record)">查看SKU详情</a-button>
          <a-button type="primary" @click="openChangeSkusModal(record)">修改价格库存</a-button>
        </div>
      </template>
    </Table>
    <SkusModal ref="SkusModal"></SkusModal>
    <DeleteGoodsModal @delete="getData()" ref="DeleteGoodsModal"></DeleteGoodsModal>
    <ChangeSkusModal ref="ChangeSkusModal"></ChangeSkusModal>
  </div>
</template>
<script>
import HeaderView from "@/views/base/components/header_view"
import tableInfoHandler from "./table_info"
import { getProductList } from "./good_manage_api"
import SearchBar from "./components/search_bar"
import { message } from "ant-design-vue"
import SkusModal from "./components/skus_modal"
import DeleteGoodsModal from "./components/delete_goods_modal"
import ChangeSkusModal from "./components/change_skus_modal"
export default {
  components: { SearchBar, HeaderView, SkusModal, ChangeSkusModal, DeleteGoodsModal },
  data() {
    return {
      mallCopyActiveKey: "1",
      queryParams: { authorizeCode: "", goodsName: "", outerGoodsId: "" },
      templateId: null,
      mallType: "pdd",
      tableInfo: {
        page: 1,
        pageSize: 100,
        showTotal: (total) => `共 ${total} 个商品`,
        pageSizeOptions: ["50", "100", "150"],
        list: [],
        total: 2,
        tableScroll: { x: "1300px", y: "calc(100vh - 285px)" },
        loading: false,
        columns: tableInfoHandler.columns,
        rowSelection: { columnTitle: "全选" },
        selectedRowKeys: [],
        selectedRows: [],
        renderSlot: ["goods_name", "goods_SPU", "goods_Id", "XCX_Name", "goods_Type", "operate"],
        rowKey: "ItemId",
      },
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    //打开商品链接
    openDetail(id) {
      window.open(`https://mobile.yangkeduo.com/goods.html?goods_id=${id}`)
    },
    //入口 获取列表数据
    async getData() {
      this.tableInfo.loading = true

      const query = {
        page: this.tableInfo.page,
        size: this.tableInfo.pageSize,

        ...this.queryParams,
      }

      const { result, success, msg } = await getProductList(query)

      if (!success) {
        message.error(msg || "授权码无效或未购买服务", 2)
      } else if (result) {
        this.tableInfo.list = result.Data || result.Datas
        this.tableInfo.total = result.TotalNum
      }

      this.tableInfo.loading = false
    },
    //搜索类目数据
    search(e) {
      this.queryParams.goodsName = e.params.keywords
      this.queryParams.outerGoodsId = e.params.goodsId
      if (e.params.createAtTime && e.params.createAtTime.length > 0) {
        this.queryParams.createTimeStart = e.params.createAtTime[0]
        this.queryParams.createTimeEnd = e.params.createAtTime[1]
      } else {
        this.queryParams.createTimeStart = ""
        this.queryParams.createTimeEnd = ""
      }
      this.getData()
    },
    //打开商品详情
    openGoodsInfo(item) {
      this.$refs.SkusModal.open(item)
    },
    //打开批量删除商品
    openGoodsDeleteModal() {
      this.$refs.DeleteGoodsModal.open(this.tableInfo.selectedRows, this.queryParams, this.tableInfo)
    },
    //打开修改sku
    openChangeSkusModal(item) {
      this.$refs.ChangeSkusModal.open(item, this.tableInfo.selectedRows, this.tableInfo.pageSize)
    },
    //切换分页配置
    changePage(page, size) {
      this.tableInfo.page = page
      this.tableInfo.pageSize = size
      this.getData()
    },
  },
}
</script>

<style scoped lang="less">
@import "./index";
</style>
